import React from 'react';
import { cn } from '@/lib/utils';
import { useLoadingPreset } from '@/hooks/shared/useOrgPreset';

interface LoadingMarkProps {
  className?: string;
  /** Container da imagem (Tailwind): ex. h-32 w-32 md:h-40 md:w-40 */
  sizeClassName?: string;
}

/**
 * Logo da tela de carregamento — mesmo asset e animação do protótipo Vertto (`Loading.jsx`): `/icone.png` + `animate-loading-float`.
 * Org com preset de marca (Atticus.hub) troca o "tt" pela marca dela, com a mesma animação.
 */
export function LoadingMark({ className, sizeClassName = 'h-32 w-32 md:h-40 md:w-40' }: LoadingMarkProps) {
  const preset = useLoadingPreset();
  return (
    <div className={cn('relative flex shrink-0 items-center justify-center', sizeClassName, className)}>
      <img
        src={preset?.loading.markSrc ?? '/icone.png'}
        alt=""
        width={160}
        height={160}
        decoding="async"
        className="max-h-full max-w-full object-contain animate-loading-float"
      />
    </div>
  );
}
